import gql from 'graphql-tag';

const UPDATE_SHIPPING_DATA = gql`mutation updateShippingPrice ($input: UpdateShippingPriceInput) {
    updateShippingPrice (input: $input) {
        status
        message
        data
    }
}`;

export default UPDATE_SHIPPING_DATA;
